/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  return this.__data__['delete'](key);
}

export default stackDelete;



//////////////////
// WEBPACK FOOTER
// ../ckeditor5-utils/src/lib/lodash/_stackDelete.js
// module id = 308
// module chunks = 0